import { useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useMessageManager } from '@framework/message';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { IDictionaryCurrency } from '@/creditflowresearch/domain/vo/IDictionary';

interface IUseGetCurrenciesReturn {
  isFetching: boolean,
  collection: IDictionaryCurrency[],
  getCurrenciesList: () => Promise<void>,
}

const useCurrencies = (): IUseGetCurrenciesReturn => {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [collection, setCollection] = useState<IDictionaryCurrency[]>([]);
  const { getErrorMessage } = useMessageManager();

  const getCurrenciesList = async (): Promise<void> => {
    setIsFetching(true);

    try {
      const currencyRepository = container.get<DictionaryRepository>(DictionaryRepository);
      const response = await currencyRepository.getCurrencies();
      setCollection(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return useMemo(() => ({
    isFetching,
    collection,
    getCurrenciesList,
  }), [
    isFetching,
    collection,
    getCurrenciesList,
  ]);
};

export default useCurrencies;
